import React, { useState, useEffect, useContext } from "react";
import ImageRatingBox from "./../../components/ImageRatingBlock";
import { GeneralImageRatingContainer } from "./ImageRatingContainer.styled";
import {
  ALL_QUESTION_CATEGORIES,
  ALL_ANSWER_CATEGORY,
} from "../../GraphQL/Queries";
import {
  CREATE_QUESTION_BANK,
  CREATE_QUESTION_SURVEY,
  UPDATE_QUESTION_BANK,
  UPDATE_QUESTION_SURVEY,
  CREATE_ANSWER_QUESTION_SURVEY,
  CREATE_FORM_QUESTION,
  UPDATE_FORM_QUESTION,
  UPDATE_FORM_QUESTION_STATUS,
} from "../../GraphQL/Mutations";
import { useMutation, useLazyQuery, useQuery } from "@apollo/client";
import StarRoundedIcon from "@material-ui/icons/StarRounded";
import FavoriteRoundedIcon from "@material-ui/icons/FavoriteRounded";

import { getStateLogin } from "../LayoutHome/stateLogin";
import { ContextQuestions } from "../../Store/StoreQuestions";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import { NotificationManager } from "react-notifications";
import { clientPolicyIngsight } from "../../App";
import { messages } from "../../util/message";

const ImageRatingContainer = (globalProps) => {
  const { identity, dataSurvey } = globalProps;
  const [stateQuestionsReducer, dispatch] = useContext(ContextQuestions);
  const [title, setTitle] = useState("");
  const [qualification, setQualification] = useState(0);
  const [colorPicker, setColorPicker] = useState("#FFC502");
  const [selectImage, setSelectImage] = useState("star");
  const [mandatory, setMandatory] = useState(false);
  const [showLoader, setshowLoader] = useState(false);

  const [refTitle, setRefTitle] = useState("");
  const [refIsMandatory, setRefIsMandatory] = useState(false);
  const [refValidationText, setRefValidationText] = useState("");
  const [refCategory, setRefCategory] = useState("0");

  const [refCantImage, setCantImage] = useState(2);
  const [valCategoryAnswer, setCategoryAnswer] = useState(1);
  const [categories, setcategories] = useState([]);

  const [createFormQuestion] = useMutation(CREATE_FORM_QUESTION, {
    client: clientPolicyIngsight,
  });
  const [updateFormQuestion] = useMutation(UPDATE_FORM_QUESTION, {
    client: clientPolicyIngsight,
  });
  const [updateFormQuestionStatus] = useMutation(UPDATE_FORM_QUESTION_STATUS, {
    client: clientPolicyIngsight,
  });
  const [createQuestionBank] = useMutation(CREATE_QUESTION_BANK);
  const [createQuestionSurvey] = useMutation(CREATE_QUESTION_SURVEY);
  const [updateQuestionBank] = useMutation(UPDATE_QUESTION_BANK);
  const [updateQuestionSurvey] = useMutation(UPDATE_QUESTION_SURVEY);
  const [createAnswerQuestionSurvey] = useMutation(
    CREATE_ANSWER_QUESTION_SURVEY
  );
  const { data: answerCat } = useQuery(ALL_ANSWER_CATEGORY);
  const [getQuestionCategories, { loading, error }] = useLazyQuery(
    ALL_QUESTION_CATEGORIES,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (!data.allCategoriesQuestion.withError) {
          const allCategories = data.allCategoriesQuestion.outputData.map(
            (c) => ({ ...c })
          );
          if (dataSurvey?.isGlobal) {
            setcategories(
              allCategories.filter((f) => f.description === "Global")
            );
          } else {
            setcategories(
              allCategories.filter((f) => f.description !== "Global")
            );
          }
        }
      },
    }
  );
  const [showTooltipDescription, setShowTooltipDescription] = useState(false);
  const [tooltipInformationCheck, setTooltipInformationCheck] = useState(false);
  const [tooltipDescriptionText, setTooltipDescriptionText] = useState("");
  const [configQuestionStyle, setconfigQuestionStyle] = useState({
    question: {
      fontFamily: "",
      fontWeight: "",
      fontStyle: "",
      textDecoration: "",
      fontSize: "",
      color: "",
    },
    answer: {
      fontFamily: "",
      fontWeight: "",
      fontStyle: "",
      textDecoration: "",
      fontSize: "",
      color: "",
    },
    customStyle: false,
    background: "",
    alignment: "",
    typeQuestion: "ImageRating",
    cantElements: 0,
    colorPicker: "",
    nameShape: "",
    tooltip: {
      status: tooltipInformationCheck,
      descriptionText: tooltipDescriptionText,
    },
  });

  const changeTooltipInformationCheck = (status) => {
    configQuestionStyle.tooltip.status = status;
    let newConfigQuestionStyle = configQuestionStyle;
    setconfigQuestionStyle(newConfigQuestionStyle);
    setTooltipInformationCheck(status);
  };

  useEffect(() => {
    if (globalProps.GidQuestionSurvey) {
      let jsonConfSurveyQuestion = JSON.parse(globalProps.GjsonConfiguration);

      setTitle(globalProps.GnameQuestion);
      setRefTitle(globalProps.GnameQuestion);

      setQualification();
      setColorPicker(jsonConfSurveyQuestion.colorPicker);
      setSelectImage(jsonConfSurveyQuestion.nameShape);
      setconfigQuestionStyle(jsonConfSurveyQuestion);
      setMandatory(
        globalProps.GisMandatory && globalProps.GisMandatory !== null
          ? globalProps.GisMandatory
          : false
      );
      setRefIsMandatory(globalProps.GisMandatory);
      setRefValidationText(globalProps.GvalidationText);

      setRefCategory(globalProps.GidCategoryQuestion);
      setCantImage(jsonConfSurveyQuestion.cantElements);

      switch (jsonConfSurveyQuestion.nameShape) {
        case "star":
          setCategoryAnswer(1);
          break;
        case "heart":
          setCategoryAnswer(1);
          break;
        case "numbers":
          setCategoryAnswer(6);
          break;
        default:
          setCategoryAnswer(1);
      }
    }
    getQuestionCategories();
  }, [
    globalProps.GidCategoryQuestion,
    globalProps.GidQuestionSurvey,
    globalProps.GisMandatory,
    globalProps.GjsonConfiguration,
    globalProps.GnameQuestion,
    globalProps.GvalidationText,
  ]);

  useEffect(() => {
    if (globalProps.GjsonConfiguration !== "") {
      const parsedJSON = JSON.parse(globalProps.GjsonConfiguration);
      if (parsedJSON.tooltip) {
        setTooltipInformationCheck(parsedJSON.tooltip.status);
        setTooltipDescriptionText(parsedJSON.tooltip.descriptionText);
      }
    }
  }, []);

  useEffect(() => {}, [valCategoryAnswer]);
  let loadCategories = () => {
    if (loading) return <option key="0">Loading...</option>;
    if (error) return <option key="0">Error :(</option>;
    if (!loading && !error)
      return categories.map(
        ({ recordState, description, idCategoryQuestion }) => {
          if (recordState.toUpperCase() === "ACTIVE") {
            return (
              <option key={idCategoryQuestion} value={idCategoryQuestion}>
                {description}
              </option>
            );
          }
          return null;
        }
      );
  };
  let chooiseSelectImage = () => {
    let StarRounded = (
      <StarRoundedIcon
        className="icon-selected"
        style={{ fill: colorPicker }}
      ></StarRoundedIcon>
    );

    switch (selectImage) {
      case "star":
        return StarRounded;
      case "heart":
        return (
          <FavoriteRoundedIcon
            className="icon-selected"
            style={{ fill: colorPicker }}
          ></FavoriteRoundedIcon>
        );
      case "numbers":
        return null;
      default:
        return StarRounded;
    }
  };
  let updateInQuestionSurvey = (
    idInBank,
    isMandatory,
    cantElements,
    nameShape,
    colorPicker,
    category
  ) => {
    configQuestionStyle.cantElements = cantElements;
    configQuestionStyle.nameShape = nameShape;
    configQuestionStyle.colorPicker = colorPicker;
    updateQuestionSurvey({
      variables: {
        idQuestionSurvey: globalProps.GidQuestionSurvey,
        idQuestion: idInBank,
        idSurvey: globalProps.GidSurvey,
        jsonConfiguration: JSON.stringify(configQuestionStyle),
        isMandatory: isMandatory,
        order: globalProps.Gorder,
        active: true,
        lastUpdateUser: getStateLogin(),
      },
    }).then((response) => {
      dispatch({
        type: "UPDATE_QUESTIONS",
        payload: {
          GindexQuestion: globalProps.GindexQuestion,
          GisEdit: false,
          GnameQuestion: title,
          GidCategoryQuestion: category,
          GisMandatory: mandatory,
          Gorder: globalProps.Gorder,
          GvalidationText: refValidationText,
          GjsonConfiguration: JSON.stringify(configQuestionStyle),
        },
      });
      setshowLoader(false);
    });
  };
  let saveQuestionSurvey = (
    idQuestion,
    isMandatory,
    cantElements,
    nameShape,
    colorPicker,
    copyText
  ) => {
    configQuestionStyle.cantElements = cantElements;
    configQuestionStyle.nameShape = nameShape;
    configQuestionStyle.colorPicker = colorPicker;
    createQuestionSurvey({
      variables: {
        idQuestion: idQuestion,
        idSurvey: globalProps.GidSurvey,
        jsonConfiguration: JSON.stringify(configQuestionStyle),
        isMandatory: isMandatory,
        order: globalProps.Gorder,
        active: true,
        createUser: getStateLogin(),
      },
    }).then((response) => {
      if (copyText !== "") {
        dispatch({
          type: "CLONE_QUESTION",
          payload: {
            Gtype: "ImageRating",
            GindexQuestion: globalProps.GindexQuestion + 1,
            Gactive: true,
            GidSurvey: globalProps.GidSurvey,
            GidQuestion: idQuestion,
            GidCategoryQuestion: refCategory,
            GnameQuestion: title + copyText,
            GvalidationText: refValidationText,
            GidQuestionSurvey: response.data.createQuestionSurvey,
            GisMandatory: mandatory,
            GjsonConfiguration: JSON.stringify(configQuestionStyle),
            Gorder: globalProps.Gorder + 1,
            GisEdit: false,
            GisDependent: false,
            GidParentQuestion: null,
            GdependentAnswer: null,
            clonePosition: globalProps.GindexQuestion + 1,
          },
        });
      } else {
        dispatch({
          type: "SAVE_QUESTIONS",
          payload: {
            GindexQuestion: globalProps.GindexQuestion,
            GisEdit: false,
            GnameQuestion: title,
            GidCategoryQuestion: refCategory,
            GisMandatory: mandatory,
            Gorder: globalProps.Gorder,
            GvalidationText: refValidationText,
            GidQuestion: idQuestion,
            GidQuestionSurvey: response.data.createQuestionSurvey,
            GjsonConfiguration: JSON.stringify(configQuestionStyle),
          },
        });
      }
      setshowLoader(false);
      createAnswerQuestionSurvey({
        variables: {
          idQuestionSurvey: response.data.createQuestionSurvey,
          idCategoryAnswer: valCategoryAnswer,
          createUser: getStateLogin(),
        },
      }).then((data) => {
        let arr = answerCat.allCategoriesAnswer.filter(
          (el) => el.idCategoryAnswer === valCategoryAnswer
        );
        let idAdty = arr[0].additionalDataType;
        let parameters = "";
        if (idAdty !== "RATING") {
          parameters = arr[0].additionalDataParameters;
          let replacedOne = parameters.replace("@initialValue", 2);
          parameters = replacedOne.replace("@endValue", cantElements);
        }
      });
    });
  };
  const updateQuestion = () => {
    configQuestionStyle.validationText = refIsMandatory
      ? refValidationText
      : "";
    updateFormQuestion({
      variables: {
        idQuestionForm: globalProps.GidQuestion,
        questionTitle: refTitle,
        questionType: "IMAGE_RATING",
        isMandatory: refIsMandatory,
        questionOrder: globalProps.Gorder,
        jsonConfiguration: JSON.stringify(configQuestionStyle),
      },
    })
      .then((res) => {
        dispatch({
          type: "UPDATE_QUESTIONS",
          payload: {
            GindexQuestion: globalProps.GindexQuestion,
            GisEdit: false,
            GnameQuestion: refTitle,
            GidCategoryQuestion: "",
            GisMandatory: refIsMandatory,
            Gorder: globalProps.Gorder,
            GvalidationText: refIsMandatory ? refValidationText : "",
            GjsonConfiguration: JSON.stringify(configQuestionStyle),
          },
        });
        setshowLoader(false);
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };
  const createQuestion = (clone) => {
    let copyText = clone ? " - Copy" : "";
    configQuestionStyle.validationText = refIsMandatory
      ? refValidationText
      : "";
    createFormQuestion({
      variables: {
        idForm: globalProps.GidSurvey,
        questionTitle: refTitle + copyText,
        questionType: "IMAGE_RATING",
        jsonConfiguration: JSON.stringify(configQuestionStyle),
        isMandatory: refIsMandatory,
        questionOrder: globalProps.Gorder,
      },
    })
      .then((res) => {
        if (res?.data?.createFormQuestion?.idForm) {
          let idQuestion = res.data.createFormQuestion.idQuestionForm;
          if (copyText !== "") {
            dispatch({
              type: "CLONE_QUESTION",
              payload: {
                Gtype: "ImageRating",
                GindexQuestion: globalProps.GindexQuestion + 1,
                Gactive: true,
                GidSurvey: globalProps.GidSurvey,
                GidQuestion: idQuestion,
                GidCategoryQuestion: "",
                GnameQuestion: refTitle + copyText,
                GvalidationText: refIsMandatory ? refValidationText : "",
                GidQuestionSurvey: idQuestion,
                GisMandatory: refIsMandatory,
                GjsonConfiguration: JSON.stringify(configQuestionStyle),
                Gorder: globalProps.Gorder + 1,
                GisEdit: false,
                GisDependent: false,
                GidParentQuestion: null,
                GdependentAnswer: null,
                clonePosition: globalProps.GindexQuestion + 1,
              },
            });
          } else {
            dispatch({
              type: "SAVE_QUESTIONS",
              payload: {
                GindexQuestion: globalProps.GindexQuestion,
                GisEdit: false,
                GnameQuestion: refTitle,
                GidCategoryQuestion: "",
                GisMandatory: refIsMandatory,
                Gorder: globalProps.Gorder,
                GvalidationText: refIsMandatory ? refValidationText : "",
                GidQuestion: idQuestion,
                GidQuestionSurvey: idQuestion,
                GjsonConfiguration: JSON.stringify(configQuestionStyle),
              },
            });
          }
          setshowLoader(false);
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };
  const saveFormQuestion = (clone) => {
    try {
      let title = refTitle;
      let isMandatory = refIsMandatory;
      let cantElements = refCantImage;
      let nameShape = selectImage;
      configQuestionStyle.cantElements = cantElements;
      configQuestionStyle.nameShape = nameShape;
      configQuestionStyle.colorPicker = colorPicker;
      if (
        title.trim() !== "" &&
        ((isMandatory && refValidationText.trim() !== "") ||
          (tooltipInformationCheck && tooltipDescriptionText.trim() !== "") ||
          !isMandatory ||
          !tooltipInformationCheck)
      ) {
        if (
          !tooltipInformationCheck ||
          (tooltipInformationCheck && tooltipDescriptionText !== "")
        ) {
          setshowLoader(true);
          if (isMandatory && refValidationText !== "") {
            if (globalProps.GidQuestionSurvey && !clone) {
              updateQuestion();
            } else {
              createQuestion(clone);
            }
          } else {
            if (!isMandatory) {
              if (globalProps.GidQuestionSurvey && !clone) {
                updateQuestion();
              } else {
                createQuestion(clone);
              }
            } else if (isMandatory && refValidationText === "") {
              if (globalProps.GidQuestionSurvey && !clone) {
                updateQuestion();
              } else {
                createQuestion(clone);
              }
            }
          }
        } else {
          handleNoTooltipDesMessage();
        }
      } else {
        handleNoQuestionTitle();
        handleNoMandatoryText();
        handleNoTooltipDesMessage();
      }
    } catch (error) {
      const errorMessage = error.message.split("\n")[0];
      NotificationManager.error(errorMessage, "", 5000);
    }
  };
  let saveQuestionBank = (clone) => {
    try {
      let title = refTitle;
      let category = refCategory;
      let isMandatory = refIsMandatory;
      let cantElements = refCantImage;
      let nameShape = selectImage;
      if (
        title.trim() !== "" &&
        parseInt(category) !== 0 &&
        ((isMandatory && refValidationText !== "") ||
          (tooltipInformationCheck && tooltipDescriptionText !== "") ||
          !isMandatory ||
          !tooltipInformationCheck)
      ) {
        if (
          !tooltipInformationCheck ||
          (tooltipInformationCheck && tooltipDescriptionText !== "")
        ) {
          setshowLoader(true);
          let copyText = clone ? " - Copy" : "";
          let validationText = refValidationText;
          if (isMandatory && refValidationText !== "") {
            if (globalProps.GidQuestionSurvey && !clone) {
              updateQuestionBank({
                variables: {
                  idQuestion: globalProps.GidQuestion,
                  nameQuestion: title,
                  validationText: validationText,
                  idCategoryQuestion: parseInt(category),
                  isMandatory: isMandatory,
                  order: globalProps.Gorder,
                  active: true,
                  lastUpdateUser: getStateLogin(),
                },
              }).then(() => {
                updateInQuestionSurvey(
                  globalProps.GidQuestion,
                  isMandatory,
                  cantElements,
                  nameShape,
                  colorPicker,
                  category
                );
              });
            } else {
              createQuestionBank({
                variables: {
                  nameQuestion: title + copyText,
                  validationText: validationText,
                  idCategoryQuestion: parseInt(category),
                  active: true,
                  createUser: getStateLogin(),
                },
              }).then((saveResponse) => {
                saveQuestionSurvey(
                  saveResponse.data.createQuestionBank,
                  isMandatory,
                  cantElements,
                  nameShape,
                  colorPicker,
                  copyText
                );
              });
            }
          } else {
            if (!isMandatory) {
              if (globalProps.GidQuestionSurvey && !clone) {
                updateQuestionBank({
                  variables: {
                    idQuestion: globalProps.GidQuestion,
                    nameQuestion: title,
                    validationText: "",
                    idCategoryQuestion: parseInt(category),
                    active: true,
                    lastUpdateUser: getStateLogin(),
                  },
                })
                  .then(() => {
                    updateInQuestionSurvey(
                      globalProps.GidQuestion,
                      isMandatory,
                      cantElements,
                      nameShape,
                      colorPicker,
                      category
                    );
                  })
                  .catch((error) => {
                    setshowLoader(false);
                    const errorMessage = error.message.split("\n")[0];
                    NotificationManager.error(errorMessage, "", 5000);
                  });
              } else {
                createQuestionBank({
                  variables: {
                    nameQuestion: title + copyText,
                    validationText: "",
                    idCategoryQuestion: parseInt(category),
                    active: true,
                    createUser: getStateLogin(),
                  },
                })
                  .then((saveResponse) => {
                    saveQuestionSurvey(
                      saveResponse.data.createQuestionBank,
                      isMandatory,
                      cantElements,
                      nameShape,
                      colorPicker,
                      copyText
                    );
                  })
                  .catch((error) => {
                    setshowLoader(false);
                    const errorMessage = error.message.split("\n")[0];
                    NotificationManager.error(errorMessage, "", 5000);
                  });
              }
            } else if (isMandatory && validationText === "") {
              if (globalProps.GidQuestionSurvey && !clone) {
                updateQuestionBank({
                  variables: {
                    idQuestion: globalProps.GidQuestion,
                    nameQuestion: title,
                    validationText: validationText,
                    idCategoryQuestion: parseInt(category),
                    isMandatory: isMandatory,
                    order: globalProps.Gorder,
                    active: true,
                    lastUpdateUser: getStateLogin(),
                  },
                }).then(() => {
                  updateInQuestionSurvey(
                    globalProps.GidQuestion,
                    isMandatory,
                    cantElements,
                    nameShape,
                    colorPicker,
                    category
                  );
                });
              } else {
                createQuestionBank({
                  variables: {
                    nameQuestion: title + copyText,
                    validationText: validationText,
                    idCategoryQuestion: parseInt(category),
                    active: true,
                    createUser: getStateLogin(),
                  },
                }).then((saveResponse) => {
                  saveQuestionSurvey(
                    saveResponse.data.createQuestionBank,
                    isMandatory,
                    cantElements,
                    nameShape,
                    colorPicker,
                    copyText
                  );
                });
              }
            }
          }
        } else {
          handleNoTooltipDesMessage();
        }
      } else {
        handleNoQuestionTitle();
        handleNoCategory(category);
        handleNoMandatoryText(isMandatory);
        handleNoTooltipDesMessage();
      }
    } catch (error) {
      const errorMessage = error.message.split("\n")[0];
      NotificationManager.error(errorMessage, "", 5000);
    }
  };

  let handleNoQuestionTitle = () => {
    if (title.trim() === "") {
      NotificationManager.warning(messages.QuestionTitle);
    }
  };

  let handleNoCategory = (category) => {
    if (parseInt(category) === 0) {
      NotificationManager.warning(messages.QuestionCategory);
    }
  };

  let handleNoMandatoryText = (isMandatory) => {
    if (isMandatory && refValidationText === "") {
      NotificationManager.warning(messages.QuestionMandatory);
    }
  };

  let handleNoTooltipDesMessage = () => {
    if (tooltipInformationCheck && tooltipDescriptionText === "") {
      NotificationManager.warning(messages.QuestionTooltipDescription);
    }
  };

  let handleEdit = () => {
    if (
      stateQuestionsReducer.questions.filter((f) => f.GisEdit === true).length
    ) {
      NotificationManager.warning(
        "All questions must be saved before to edit another question",
        "",
        5000
      );
      return;
    }
    dispatch({
      type: "EDIT_QUESTIONS",
      payload: {
        GindexQuestion: globalProps.GindexQuestion,
        GisEdit: true,
      },
    });
  };

  let handleCancel = () => {
    let objG = stateQuestionsReducer.questions[globalProps.GindexQuestion];

    let jsonConfSurveyQuestion = JSON.parse(objG.GjsonConfiguration);

    setTitle(objG.GnameQuestion);
    setRefTitle(objG.GnameQuestion);
    setRefCategory(objG.GidCategoryQuestion);
    setMandatory(
      objG.GisMandatory && objG.GisMandatory !== null
        ? objG.GisMandatory
        : false
    );
    setRefIsMandatory(objG.GisMandatory);
    setRefValidationText(objG.GvalidationText);
    setconfigQuestionStyle(jsonConfSurveyQuestion);
    setSelectImage(jsonConfSurveyQuestion.nameShape);
    setCantImage(jsonConfSurveyQuestion.cantElements);

    if (jsonConfSurveyQuestion.tooltip) {
      setTooltipInformationCheck(jsonConfSurveyQuestion.tooltip.status);
      setTooltipDescriptionText(jsonConfSurveyQuestion.tooltip.descriptionText);
    }

    dispatch({
      type: "CANCEL_QUESTIONS",
      payload: {
        GindexQuestion: globalProps.GindexQuestion,
        GisEdit: false,
      },
    });
  };

  const deleteNonSavedQuestion = () => {
    setshowLoader(false);
    let copy = JSON.parse(JSON.stringify(stateQuestionsReducer));
    copy.questions.splice(globalProps.GindexQuestion, 1);
    copy.questions.map((q, index) => {
      q.GindexQuestion = index;
      q.Gorder = index + 1;
    });
    dispatch({ type: "CLEAN_QUESTIONS" });
    dispatch({ type: "DELETE_QUESTIONS", payload: copy });
  };

  const handleDeleteFormQuestion = () => {
    setshowLoader(true);
    if (globalProps.GidQuestion) {
      updateFormQuestionStatus({
        variables: {
          idFormQuestion: globalProps.GidQuestion,
          newFormQuestionStatus: "DELETED",
        },
      })
        .then((res) => {
          if (res?.data?.changeStatusFormQuestion?.idQuestionForm) {
            setshowLoader(false);
            let copy = JSON.parse(JSON.stringify(stateQuestionsReducer));
            copy.questions.splice(globalProps.GindexQuestion, 1);
            copy.questions.forEach((q, index) => {
              q.GindexQuestion = index;
              q.Gorder = index + 1;
            });
            dispatch({ type: "CLEAN_QUESTIONS" });
            dispatch({ type: "DELETE_QUESTIONS", payload: copy });
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else {
      deleteNonSavedQuestion();
    }
  };

  let handleDelete = () => {
    setshowLoader(true);
    if (globalProps.GidQuestionSurvey !== 0) {
      updateQuestionBank({
        variables: {
          idQuestion: globalProps.GidQuestion,
          active: false,
          lastUpdateUser: getStateLogin(),
        },
      }).then((result) => {
        updateQuestionSurvey({
          variables: {
            idQuestionSurvey: globalProps.GidQuestionSurvey,
            idQuestion: globalProps.GidQuestion,
            idSurvey: globalProps.GidSurvey,
            jsonConfiguration: "",
            isMandatory: false,
            order: 0,
            active: false,
            lastUpdateUser: getStateLogin(),
          },
        }).then((resultUpdate) => {
          setshowLoader(false);
          let copy = JSON.parse(JSON.stringify(stateQuestionsReducer));
          copy.questions.splice(globalProps.GindexQuestion, 1);
          copy.questions.forEach((q, index) => {
            q.GindexQuestion = index;
            q.Gorder = index + 1;
          });
          dispatch({ type: "CLEAN_QUESTIONS" });
          dispatch({ type: "DELETE_QUESTIONS", payload: copy });
        });
      });
    } else {
      deleteNonSavedQuestion();
    }
  };

  let handleTextAreaText = (value) => {
    setTooltipDescriptionText(value);
    configQuestionStyle.tooltip.descriptionText = value;
    let newConfigQuestionStyle = configQuestionStyle;
    setconfigQuestionStyle(newConfigQuestionStyle);
  };

  return (
    <GeneralImageRatingContainer>
      <ImageRatingBox
        title={title}
        setTitle={setTitle}
        qualification={qualification}
        setQualification={setQualification}
        colorPicker={colorPicker}
        setColorPicker={setColorPicker}
        selectImage={selectImage}
        setSelectImage={setSelectImage}
        mandatory={mandatory}
        setMandatory={setMandatory}
        editable={globalProps.GisEdit}
        loadCategories={loadCategories}
        chooiseSelectImage={chooiseSelectImage}
        refTitle={refTitle}
        setRefTitle={setRefTitle}
        refIsMandatory={refIsMandatory}
        setRefIsMandatory={setRefIsMandatory}
        refValidationText={refValidationText}
        setRefValidationText={setRefValidationText}
        refCategory={refCategory}
        setRefCategory={setRefCategory}
        saveQuestionBank={saveQuestionBank}
        handleEdit={handleEdit}
        handleCancel={handleCancel}
        refCantImage={refCantImage}
        setCantImage={setCantImage}
        setCategoryAnswer={setCategoryAnswer}
        configQuestionStyle={configQuestionStyle}
        setconfigQuestionStyle={setconfigQuestionStyle}
        handleDeleteQuestion={() => {
          if (identity !== "form") {
            handleDelete();
          } else {
            handleDeleteFormQuestion();
          }
        }}
        idQuestionSurvey={globalProps.GidQuestionSurvey}
        globalProps={globalProps}
        categories={categories}
        identity={identity}
        saveFormQuestion={saveFormQuestion}
        tooltipInformationCheck={tooltipInformationCheck}
        tooltipDescriptionText={tooltipDescriptionText}
        setShowTooltipDescription={setShowTooltipDescription}
        handleTextAreaText={handleTextAreaText}
        changeTooltipInformationCheck={changeTooltipInformationCheck}
        showTooltipDescription={showTooltipDescription}
      />
      {showLoader && <ModalLoader></ModalLoader>}
    </GeneralImageRatingContainer>
  );
};

export default ImageRatingContainer;
